import React from 'react';
import {Card, ListGroup} from 'react-bootstrap';

const apiURL = process.env.REACT_APP_API_URL;

const DocumentsCard = ({token, documents}) => (
    <Card className="mb-4">
        <Card.Header as="h4" className="py-3">Documents rattachés au dossier</Card.Header>
        <ListGroup variant="flush">
            {documents.length === 0 && <ListGroup.Item>Aucun document.</ListGroup.Item>}
            {documents.map((doc) => (
                <ListGroup.Item key={doc.key} className="d-flex justify-content-between align-items-center">
                    <span><strong>{doc.label}</strong> — {doc.fileName}</span>
                    <a
                        className="btn btn-sm btn-outline-primary"
                        href={`${apiURL}/api/public/tiers-payant/${token}/file/${doc.key}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        Télécharger
                    </a>
                </ListGroup.Item>
            ))}
        </ListGroup>
    </Card>
);

export default DocumentsCard;
